'use strict'
import React, { useEffect } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
import Grid from '@mui/material/Grid'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
// import CheckBoxIcon from '@mui/icons-material/CheckBox'
import ImageList from '@mui/material/ImageList'
import ImageListItem from '@mui/material/ImageListItem'
import ImageListItemBar from '@mui/material/ImageListItemBar'
import Pagination from '@mui/material/Pagination'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDSnackbar from 'components/MDSnackbar'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'

// Material Dashboard 2 PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'
import DataTable from 'components/Tables/DataTable'

// zerouno
import authService from 'services/auth.service'
import albumService from 'services/album.service'
import mainService from 'services/image.service'
import { config } from 'variables/Config.js'
import { useParams, Link } from 'react-router-dom'

export default function ImageTable () {
  const [objId, setObjId] = React.useState(0)
  const { idAlbum } = useParams()
  const [obj, setObj] = React.useState([])
  const [objects, setObjects] = React.useState([])
  const [filtered, setFiltered] = React.useState([])
  const [showSnackbar, setShowSnackbar] = React.useState({ sh: false, msg: '', color: 'success' })
  const [openConfirm, setOpenConfirm] = React.useState(false)
  const [page, setPage] = React.useState(1)
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))
  const loggedUser = authService.user()

  const handleChangePagination = (event, value) => {
    setPage(value)
  }

  useEffect(() => {
    fetchObjects()
  }, [])

  const fetchObjects = () => {
    albumService.get(idAlbum).then(
      (response) => {
        setObj(response.data)
      })
      .then(() => {
        return mainService.getAll(idAlbum)
      })
      .then((response2) => {
        setObjects(response2.data)
        setFiltered(response2.data)
      })
      .catch((error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      })
  }

  // Delete
  const deleteObject = () => {
    setOpenConfirm(false)
    mainService.remove(idAlbum, objId).then(
      (response) => {
        setShowSnackbar({ sh: true, msg: 'operazione effettuata con successo', color: 'success' })
        fetchObjects()
      },
      (error) => {
        setShowSnackbar({ sh: true, msg: error.response ? error.response.data.message : 'errore di ricezione dati', color: 'error' })
      }
    )
  }

  function handleSearch (event) {
    const v = event.target.value
    const qArray = v.split(' ')
    const result = objects.filter(item => {
      const allW = qArray.every((w) => {
        return (item.title.includes(w) || item.description.includes(w) || item.tags.includes(w))
      })
      return allW
    })
    setFiltered(result)
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox display='flex'>
            <MDBox
              display='flex'
              justifyContent='center'
              alignItems='center'
              width='4rem'
              height='4rem'
              variant='gradient'
              bgColor='info'
              color='white'
              shadow='md'
              borderRadius='xl'
              ml={3}
              mt={-2}
            >
              <Icon fontSize='medium' color='inherit'>
                photo
              </Icon>
            </MDBox>
            <MDTypography variant='h5' sx={{ mt: 2, mb: 1, ml: 2 }}>
              Album {obj.name}
            </MDTypography>
          </MDBox>

          <Grid container spacing={2} p={2}>
            <Grid item xs={12} md={6}>
              <MDButton color='secondary' component={Link} to='/albums' sx={{ m: 1 }}>
                indietro
              </MDButton>
              <MDButton color='secondary' component={Link} to='/dashboard/main' sx={{ m: 1 }}>
                dashboard
              </MDButton>
              {authService.isAdmin() &&
                <MDButton color='info' component={Link} to={`/albums/${idAlbum}/images/new`} sx={{ m: 1 }}>
                  aggiungi
                </MDButton>}
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput label='Cerca Foto' defaultValue='' onChange={handleSearch} sx={{ width: '100%' }} />
            </Grid>

          </Grid>

          {/* <DataTable table={{ columns: columns, rows: objects }} canSearch /> */}

          <ImageList variant='masonry' cols={matches ? 4 : 1} gap={4} sx={{ p: 3 }}>
            {filtered.map((item) => (
              <ImageListItem key={item.id}>
                <img
                  src={config.SERVER_URL + '/download/min_' + item.file}
                  srcSet={`${config.SERVER_URL}/download/min_${item.file}`}
                  alt={item.title}
                  loading='lazy'
                />
                <ImageListItemBar
                  title={item.title}
                  subtitle={item.tags}
                  actionIcon={
                    <Grid container spacing={1} sx={{ mr: 1 }}>
                      <Grid item>
                        <MDButton
                          color='primary'
                          size='small'
                          iconOnly
                          href={`${config.SERVER_URL}/download/${item.file}`}
                          target='_blank'
                        >
                          <Icon>download</Icon>
                        </MDButton>

                      </Grid>
                      <Grid item>
                        <MDButton
                          color='info'
                          size='small'
                          iconOnly
                          component={Link}
                          to={`/albums/${item.albumId}/images/${item.id}`}
                        >
                          <Icon>edit</Icon>
                        </MDButton>
                      </Grid>
                      <Grid item>
                        {authService.isAdmin() &&
                          <MDButton
                            iconOnly
                            color='error'
                            size='small'
                            onClick={() => {
                              setObjId(item.id)
                              setOpenConfirm(true)
                            }}
                          >
                            <Icon>delete</Icon>
                          </MDButton>}
                      </Grid>
                    </Grid>

                  }
                />
              </ImageListItem>
            ))}

          </ImageList>
          {/* <Pagination count={objects.length / 3} color='info' page={page} onChange={handleChangePagination} /> */}

        </Card>
      </MDBox>
      <Footer />
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Confermi eliminazione?
        </DialogTitle>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)}>Annulla</MDButton>
          <MDButton onClick={deleteObject} autoFocus>Conferma</MDButton>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />
    </DashboardLayout>

  )
}
